export default [
  {
    path: "/project/:proj_id",
    component: () => import("@/layouts/ProjectLayout.vue"),
    meta: {
      authRequired: true,
    },
    children: [
      {
        path: "field/info/:type",
        name: "field-info-type",
        meta: {
          activeCode: "field-info",
        },
        component: () => import("@/views/_BS/FieldInfo.vue"),
      },

      // ========== 종사자일괄등록 ==========
      {
        path: "employees",
        name: "employees",
        meta: {
          activeCode: "employees",
        },
        component: () => import("@/views/_BS/Employees.vue"),
      },

      // ========== 폐암검진 ==========
      {
        path: "lungcancer502",
        name: "lungcancer502",
        meta: {
          activeCode: "lungcancer502",
        },
        component: () => import("@/views/_BS/Lungcancer502.vue"),
      },
      {
        path: "lungcancer503",
        name: "lungcancer503",
        meta: {
          activeCode: "lungcancer503",
        },
        component: () => import("@/views/_BS/Lungcancer503.vue"),
      },

      // ========== 정기안전보건교육 이수결과 ==========
      {
        path: "completionresults570",
        name: "completionresults570",
        meta: {
          activeCode: "completion-results",
        },
        component: () => import("@/views/_BS/CompletionResults.vue"),
      },
      {
        path: "completionresults576",
        name: "completionresults576",
        meta: {
          activeCode: "completion-results",
        },
        component: () => import("@/views/_BS/CompletionResults.vue"),
      },
      {
        path: "completionresults577",
        name: "completionresults577",
        meta: {
          activeCode: "completion-results",
        },
        component: () => import("@/views/_BS/CompletionResults.vue"),
      },

      // ==========  ==========
      {
        path: "company/info",
        name: "company-info",
        meta: {
          activeCode: "company-info",
        },
        component: () => import("@/views/_BS/CompanyInfo.vue"),
      },
    ],
  },
];
